import { array, mixed, number, object, string } from "yup";

import { LangDto } from "../common";

export interface FoodSynonymTranslationResource {
  lang: LangDto;
  name: string | null;
}

export interface FoodSynonymResource {
  id: number;
  name: string | null;
  translations: FoodSynonymTranslationResource[];
}

export const foodSynonymTranslationSchema = object({
  lang: mixed<LangDto>().oneOf(Object.values(LangDto)).required(),
  name: string().nullable().default(null),
});

export const foodSynonymSchema = object({
  id: number().required(),
  name: string().nullable().default(null),
  translations: array().of(foodSynonymTranslationSchema).required(),
});
